import { Injectable } from '@angular/core';
import { switchMap, of, catchError, throwError } from 'rxjs';
import { DonorJourneySection } from '../models/donor-journey-section.model';
import { ContentService } from './content.service';
import { ProfileInfo } from '../models/donorProfile.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class JourneySectionHelperService {

  constructor(private contentService: ContentService, private authService: AuthService) {}

  ensureDonorProfileExists() {
    const profileInfo: ProfileInfo = {
      data: {
        donor: {
          userId: this.authService.getUserId(),
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          ethnicity: '',
          relationshipToRecipient: '',
          bloodGroup: '',
        }
      }     
    };

    return this.contentService.getDonorProfile().pipe(
      catchError((error) => {
        if (error.status === 404) {
          console.log('No donor profile found. Creating...');
          return this.contentService.updateDonoranddRecipientProfileInfo(profileInfo);
        } else {
          return throwError(() => error);
        }
      })
    );
  }

  ensureJourneySectionsExist() {
    return this.contentService.getDonorJourneySectionStatusForUser().pipe(
      switchMap((sections: DonorJourneySection[]) => {
        if (sections && sections.length > 0) {
          return of(sections);
        } else {
          return this.contentService.initializeJourneySectionsForUser().pipe(
            switchMap(() => this.contentService.getDonorJourneySectionStatusForUser())
          );
        }
      }),
      catchError(error => {
        console.error('Error ensuring journey sections exist:', error);
        return throwError(() => error);
      })
    );
  }

  updateSectionStatus(sectionId: string, status: string) {
    return this.contentService.updateJourneySectionStatusForUser(sectionId, status);
  }

  linkQuestionnaireToSection(sectionId: string, questionnaireId: string) {
    return this.contentService.updateQuestionnaireIdOnJourneySectionForUser(sectionId, questionnaireId);
  }
}
